import { render, staticRenderFns } from "./FileDiff.vue?vue&type=template&id=f8e3d910&scoped=true&"
import script from "./FileDiff.vue?vue&type=script&lang=js&"
export * from "./FileDiff.vue?vue&type=script&lang=js&"
import style0 from "./FileDiff.vue?vue&type=style&index=0&id=f8e3d910&lang=scss&scoped=true&"
import style1 from "./FileDiff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e3d910",
  null
  
)

export default component.exports